export default __webpack_public_path__ + "static/media/defaultAvatar.41c95564.png";